import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import AlertItem from './AlertItem';

class PreferredSupplierAlert extends Component {
  render() {
    return (
      <AlertItem
        alert={this.props.alert}
        onIsFlaggedChange={this.props.onIsFlaggedChange}
        date={moment(this.props.alert.date).format('MMMM YYYY')}
        icon='building-o'
        title={(
          <div>
            <Link to={`/corporate/analyze/buyer/${this.props.alert.buyer.id}`}>
              {this.props.alert.buyer.name}
            </Link>
            {' '} purchased {' '}
            <strong className='u-colorRed'>
              {this.props.alert.value.percent.toFixed(1)}%
            </strong>
            {' '} of eligible items from {' '}
            {this.props.alert.value.supplier_names.join(', ')}
          </div>
        )}
        {...this.props}
      />
    );
  }
}

PreferredSupplierAlert.propsTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default PreferredSupplierAlert;
